import type { AppState } from 'types/app';

export const selectSubscriptionInfo = (state: AppState) => state.subscriptionsInfo;
